<template>
  <div>
    <div class="l-row">
      <product-status :module="module" @change="onChange"/>
    </div>
    <div class="l-row">
      <form-group label="Agrupador(es) do(s) produto(s)">
        <textarea
          class="form-textarea"
          rows="8"
          v-model="filters.productIds"
          placeholder="997, 998, 999, 1000"/>
        <small class="form-help">Utilize vírgula (,) para múltiplos agrupadores.</small>
      </form-group>

      <form-group label="SKU(s) do(s) produto(s)">
        <textarea
          class="form-textarea"
          rows="8"
          v-model="filters.skus"
          placeholder="SKU123, SKU456, SKU789"/>
        <small class="form-help">Utilize vírgula (,) para múltiplos SKUs.</small>
      </form-group>
    </div>
  </div>
</template>

<script>
  import ProductStatus from '@/components/tool/batch/shared/filters/marketplace/ProductStatus'
  import { merge } from 'lodash'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      filters: {
        status: null,
        productIds: null,
        skus: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      },
      formatCodes () {
        this.filters.marketplace.codes = this.filters.marketplace.codes.replace(/,{2,}/g, ',').replace(/, /g, '')
      },
      removeTrim () {
        this.filters.marketplace.codes = this.filters.marketplace.codes.replace(/\n/g, ',')
      }
    },
    components: {
      ProductStatus,
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Amazon.vue?1d71d2fd